<template>
  <v-select

  class="tema-eixo-combo"
    id="temas-select"
    v-model="filter.pacoteId"
    item-text="nome"
    item-name="nome"
    item-value="pacoteId"
    :items="pacotes"
    label="Pacotes"
    placeholder="Pacotes"
    v-on:change="$emit('onChange')"
    :clearable = "true"

  >
    <template slot="no-data">
      Nenhum Pacote retornado
    </template>
  </v-select>
</template>

<script>
import { pacoteAPI } from '../../pacote/API/pacoteAPI'

export default {
  name: 'ComboboxTemas',
  props: [
    'filter'
  ],
  mounted () {
    this.loadTemas()
  },
  methods: {
    loadTemas () {
      pacoteAPI.list()
        .then(resp => {
          this.pacotes = resp.data
        })
        .catch()
    }
  },
  data () {
    return {
      pacotes: []
    }
  }
}
</script>
